import React, { useEffect, useState } from 'react';
import { OFFER_ANCHOR } from './CtaButton';

/**
 * Discreet mobile-only bar. Appears once the hero CTA has scrolled out of view
 * and hides again while the final offer is on screen, so two buttons never
 * compete. It leads to the offer block, where the checkout button lives.
 */
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero-cta');
    const offer = document.getElementById('offer');
    if (!hero) return;
    const state = {
      heroVisible: true,
      offerVisible: false
    };
    const sync = () => setIsVisible(!state.heroVisible && !state.offerVisible);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) state.heroVisible = entry.isIntersecting;
        if (entry.target === offer) state.offerVisible = entry.isIntersecting;
      });
      sync();
    }, {
      rootMargin: '-8% 0px -8% 0px'
    });
    observer.observe(hero);
    if (offer) observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!isVisible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-brand-charcoal/10 bg-brand-ivory/95 px-4 pb-3 pt-3 backdrop-blur-sm transition-opacity duration-200 ease-out md:hidden ${isVisible ? 'opacity-100' : 'pointer-events-none opacity-0'}`} data-id="element-33" data-mp="28m1vvb0e9kv">
      <a href={OFFER_ANCHOR} tabIndex={isVisible ? 0 : -1} className="flex w-full items-center justify-center gap-2 rounded-[12px] bg-brand-green px-5 py-3.5 font-body text-[13px] font-semibold uppercase tracking-[0.08em] text-brand-green-text transition-colors duration-200 ease-out hover:bg-brand-green-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green focus-visible:ring-offset-2" data-id="element-34" data-mp="py830oaxyyvi">
        See the Complete System
        <span aria-hidden="true" className="text-base font-normal" data-id="element-35" data-mp="2woe9q8iu39bw">
          →
        </span>
      </a>
    </div>;
}